<template>
    <div class="app-title">
        <div class="app-title_bg"></div>
        <div class="app-title_content">
            <span class="app-title_text">{{title}}</span>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'app-title',
    props: {
        title: {
            type: String,
            default: ''
        }
    }
};
</script>

<style scoped lang="scss">
.app-title {
    position: relative;
    .app-title_bg {
        width: 114px;
        height: 22px;
        background: no-repeat var(--title-bg);
    }
    .app-title_content {
        position: absolute;
        left: 8px;
        top: 0;
        .app-title_text {
            color: var(--font-color85);
        }
    }
}
</style>
